import { makeAutoObservable } from "mobx"
import OrganizationAPI from "../utilities/OrganizationsHelper"
import endpoints from '../../endpoints'

export const DEFAULT_ORG = "DEFAULT"

export default class Organizations {
  
  title = 'Organizations'
  list = []
  selected = DEFAULT_ORG
  initialFetch = false
  orgMap = new Map();
  selectedOrgId = DEFAULT_ORG

  constructor(){
    makeAutoObservable(this)
  }

  fetchOrgs = async () => {
    const orgs = await OrganizationAPI.fetchAllOrganizations(endpoints.WEB_APP)
    this.list = orgs ? orgs : []
    this.initialFetch = true
  }

  setSelected = selected => {
    this.selectedOrgId = this.orgMap.get(selected)
    this.selected = selected
  }

  orgNames(route){
    let names = this.list ? this.list.map(org => org.name) : []
    names.sort()
    if (route === 'templates') names.unshift(DEFAULT_ORG)
    for (const org of this?.list) {
      this.orgMap.set(org?.name, org?._id || org?.id)
    }
    if (this.selected) {
      this.selectedOrgId = this.orgMap.get(this.selected)
    }
    return names
  }

  /**
   * Creates an organization with advanced configuration
   * @param {Object} orgData - Organization data object
   * @param {string} orgData.organizationName - Name of the organization
   * @param {string} orgData.identityProvider - Authentication type (MARLEY or FEDERATED)
   * @param {string} [orgData.domainName] - Domain name for FEDERATED auth
   * @param {boolean} [orgData.createSupportUser=false] - Whether to create a support user for the organization
   * @param {Object} [orgData.integration] - Integration configuration
   * @param {string} [orgData.integration.authentication] - Authentication method (KEY or OAUTH2)
   * @param {Object} [user] - User information for logging
   * @returns {Promise<Object>} The created organization object
   */
  createOrganization = async (orgData) => {
    try {
      const newOrg = await OrganizationAPI.createOrganizationRequest(orgData, endpoints.WEB_APP)
      
      // Refresh the organizations list to include the new organization
      // This is a separate operation that shouldn't fail the main creation
      try {
        await this.fetchOrgs()
      } catch (refreshError) {
        console.warn('Failed to refresh organizations list after creation:', refreshError)
      }
      
      return newOrg
    } catch (error) {
      console.error('Error creating organization:', error)
      throw error
    }
  }
}